import React, { useState, useEffect, useMemo } from 'react'
import { Row, Col, Image, Container, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import Moment from 'moment';
import { apiHandler } from '../../../api/apihandler';
import { BLOG_CATEGORY, BLOG_LIST, BLOG_TAG_LIST } from '../../../api/constants'
import { InView } from "react-intersection-observer";

// Redux Selector / Action
import { useSelector } from 'react-redux';

import loader from '../../../assets/images/page-img/page-load-loader.gif'
import BlogCard from '../../../components/blog/blogCard';
import NoDataFound from '../../../components/noDataFound';

import blog3 from '../../../assets/images/blog/03.jpg'
import blog4 from '../../../assets/images/blog/04.jpg'
import blog5 from '../../../assets/images/blog/05.jpg'
import blog6 from '../../../assets/images/blog/06.jpg'
import blog7 from '../../../assets/images/blog/07.jpg'
import blog8 from '../../../assets/images/blog/08.jpg'


const BlogList = () => {
   const rawProfileData = useSelector((state) => state.setting.setting.user_data);
   const rawGeneralSettingsData = useSelector((state) => state.setting.setting.general_settings);
   const profileData = useMemo(() => {
      if (!rawProfileData) return {};
      if (typeof rawProfileData === 'object') return rawProfileData;
      try {
         return JSON.parse(rawProfileData);
      } catch (error) {
         return {};
      }
   }, [rawProfileData]);
   const generalSettingsData = useMemo(() => {
      if (!rawGeneralSettingsData) return {};
      if (typeof rawGeneralSettingsData === 'object') return rawGeneralSettingsData;
      try {
         return JSON.parse(rawGeneralSettingsData);
      } catch (error) {
         return {};
      }
   }, [rawGeneralSettingsData]);
   const navigate = useNavigate();
   const [blogList, setBlogList] = useState([]);
   const [blogCategoryList, setBlogCategoryList] = useState([]);
   const [tagList, setTagList] = useState([]);
   const [page, setPage] = useState(1);
   const [maxPage, setMaxPage] = useState(1);
   const [categoryId, setCategoryId] = useState(0);
   const [tagId, setTagId] = useState("");
   const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
   const dummyBlogCategoryData = {
      "id": 0,
      "slug": "",
      "parent_id": null,
      "name": "All",
      "meta_title": null,
      "meta_tag": null,
      "meta_description": null,
      "created_at": null,
      "updated_at": null,
      "description": null,
      "post_last_date": null
   }

   const [isFirst, setIsFirst] = useState(true);
   useEffect(() => {
      window.scrollTo({
         top: 0,
         behavior: "smooth",
      });
      setIsFirst(false)
   }, [isFirst]);

   useEffect(() => {
      if (localStorage.getItem("uzoneAuthToken")) {
         getBlogList(1, categoryId, tagId)
         getBlogCategoryList()
         getTagList()
      } else {
         navigate('/')
      }
   }, []);

   function refreshApi() {
      setPage(1)
      getBlogList(1, categoryId, tagId)
   }

   const loadMore = (inView) => {
      if (inView) {
         if (page < maxPage) {
            getBlogList(page + 1, categoryId, tagId)
            setPage(page + 1)
         }
      }
   };

   async function getBlogList(pageVal, categoryId, tagId) {
      setShowMoreDataLoader(true)
      try {
         const res = await apiHandler(BLOG_LIST, "POST", {
            // user_id: profileData?.id,
            category_id: categoryId,
            tag_id: tagId,
            page: pageVal,
            limit: 10
         })
         if (res.data?.response?.status === 200) {
            setMaxPage(res?.data?.data?.blogs?.meta?.last_page)
            if (res?.data?.data?.blogs?.meta?.total > 0) {
               if (pageVal === 1) {
                  setBlogList(res?.data?.data?.blogs?.data)
               } else {
                  setBlogList(blogList.concat(res?.data?.data?.blogs?.data))
               }
            }
         }
      } catch (error) {
         console.error(error);
      }
      finally {
         setShowMoreDataLoader(false)
      }
   }

   async function getBlogCategoryList() {
      try {
         const res = await apiHandler(BLOG_CATEGORY, "POST", {
            page: 1,
            limit: 100
         })
         if (res.data?.response?.status === 200) {
            // setBlogCategoryList(res?.data?.data?.blogcats?.data)
            setBlogCategoryList([dummyBlogCategoryData, ...res?.data?.data?.blogcats?.data])
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   async function getTagList() {
      try {
         const res = await apiHandler(BLOG_TAG_LIST, "POST", {
            page: 1,
            limit: 100
         })
         if (res.data?.response?.status === 200) {
            setTagList(res?.data?.data?.blogtags?.data)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   function handleCategoryFilter(selectedCategoryId) {
      getBlogList(1, selectedCategoryId, "")
      setCategoryId(selectedCategoryId)
      setTagId("")
      setPage(1)
   }

   return (
      <>
         <div id='content-page' className='content-page'>
            <Container>
               <Row>
                  <Col lg={8}>
                     <div>
                        {
                           blogList?.length > 0 ? blogList.map((elm, i) => (
                              <BlogCard elm={elm} getBlogList={refreshApi} key={elm?.id} index={i} />
                           )) : <NoDataFound />
                        }
                     </div>
                     {
                        showMoreDataLoader ?
                           <div className="col-sm-12 text-center">
                              <img src={loader} alt="loader" style={{ height: "100px" }} />
                           </div> : null
                     }
                     <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                  </Col>
                  <Col lg={4}>
                     <div>
                        <Card className="card-block card-stretch card-height blog-post" style={{ border: "1px solid #edf1f7", overflow: "hidden", boxShadow: "0 8px 24px rgba(148, 163, 184, 0.08)" }}>
                           <Card.Header className="d-flex justify-content-between" style={{ background: "#f8fbff", borderBottom: "1px solid #edf1f7", padding: "10px 14px" }}>
                              <div className="header-title">
                                 <h6 className="card-title mb-0" style={{ color: "#334155", fontWeight: 600 }}>Our News Updates Category</h6>
                              </div>
                           </Card.Header>
                           <Card.Body style={{ background: "#fcfdff", padding: "10px" }}>
                              <div className="d-flex align-items-center justify-content-between mb-1">
                                 <small style={{ color: "#6b7280", fontWeight: 500, fontSize: "11px" }}>Categories</small>
                                 <span className="badge rounded-pill" style={{ background: "#f1f5f9", color: "#64748b", fontWeight: 500 }}>{blogCategoryList?.length || 0}</span>
                              </div>
                              <div className="d-grid" style={{ gap: "6px" }}>
                                 {blogCategoryList.map((elm) => {
                                    const isActive = Number(elm?.id) === Number(categoryId);
                                    return (
                                       <button
                                          type="button"
                                          key={elm?.id}
                                          onClick={() => handleCategoryFilter(elm?.id)}
                                          className="btn text-start"
                                          style={{
                                             borderRadius: "10px",
                                             border: isActive ? "1px solid #dbeafe" : "1px solid #eef2f7",
                                             background: isActive ? "#f0f7ff" : "#ffffff",
                                             color: "#334155",
                                             padding: "7px 10px",
                                             boxShadow: isActive ? "0 4px 12px rgba(191, 219, 254, 0.35)" : "none"
                                          }}
                                       >
                                          <div className="d-flex align-items-start justify-content-between">
                                             <span style={{ fontSize: "13px", fontWeight: isActive ? 700 : 600 }}>{elm?.name}</span>
                                             {isActive ? <span className="badge rounded-pill" style={{ background: "#dbeafe", color: "#3b82f6", fontSize: "10px", fontWeight: 600 }}>Active</span> : null}
                                          </div>
                                       </button>
                                    );
                                 })}
                              </div>
                           </Card.Body>
                        </Card>
                        {
                           tagList?.length > 0 ?
                              <Card className="card-block card-stretch card-height blog-post">
                                 <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                       <h4 className="card-title">Tag List</h4>
                                    </div>
                                 </Card.Header>
                                 <Card.Body>
                                    {
                                       tagList.map((elm, i) => (
                                          <>
                                             {
                                                elm?.id === tagId ?
                                                   <Button variant="primary" className="rounded-pill mb-1 me-2" key={elm?.id}
                                                      onClick={() => {
                                                         getBlogList(1, "", elm?.id)
                                                         setTagId(elm?.id)
                                                         setCategoryId("")
                                                         setPage(1)
                                                      }}>{elm?.slug}
                                                   </Button> :
                                                   <Button variant="secondary" className="rounded-pill mb-1 me-2" key={elm?.id}
                                                      onClick={() => {
                                                         getBlogList(1, "", elm?.id)
                                                         setTagId(elm?.id)
                                                         setCategoryId("")
                                                         setPage(1)
                                                      }}>{elm?.slug}
                                                   </Button>
                                             }
                                          </>
                                       ))
                                    }
                                 </Card.Body>
                              </Card> : null
                        }

                     </div>
                  </Col>
               </Row>
            </Container>
         </div>
      </>
   )
}

export default BlogList